// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  moderator: {
    flexBasis: "25%",
    display: "flex",
    overflow: "hidden",
    borderBottom: "1px solid #e7ebee", 
    position: "relative"
  }
}), { index: 1 })